/**
 * What a route shows when something under it throws, instead of React Router's developer page.
 *
 * v0.16.0 met this the hard way: Firefox refused the inbox WebSocket (the CSP did not name the
 * ws origin) by throwing an exception that is not an `Error`, and the default page printed `{}`.
 * The person sees one sentence and a reload button. What was thrown goes to the error reporter:
 * a boundary catches it, so nothing else would send it, and it is not the person's to read.
 */
import { useEffect, type JSX } from "react";
import { useRouteError } from "react-router";

import { useTranslation } from "@/i18n";
import { reportRouteError } from "@/observability/errorReporting";
import { ErrorState } from "@/ui/states";

export function RouteError(): JSX.Element {
  const { t } = useTranslation();
  const error = useRouteError();
  useEffect(() => {
    reportRouteError(error);
  }, [error]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg px-4">
      <ErrorState
        message={t("app.crash.message")}
        retryLabel={t("app.crash.reload")}
        onRetry={() => {
          window.location.reload();
        }}
      />
    </div>
  );
}
